/** 监管平台路由 */
export const manageRoutes = {
  /** 采购进度 */
  PurchaseProgressList: '/manage/purchase_progress/list',
  /** 考培列表 */
  ManageExaminationList: '/manage/examination/list',
  /** 新建考卷 */
  ManageExaminationExamCreate: '/manage/examination/exam_create',
  /** 编辑考卷 */
  ManageExaminationExamEdit: '/manage/examination/exam_edit',
  /** 考卷复制 */
  ManageExaminationExamCopy: '/manage/examination/exam_copy',
  /** 考卷详情 */
  ManageExaminationExamDetail: '/manage/examination/exam_detail',
  /** 查看答卷 */
  ExaminationExamAnswerDetail: '/manage/examination/exam_answer_detail',
  /** 参与人数 */
  ManageExaminationParticipationNum: '/manage/examination/participation_num',
  /** IO记录 */
  IoRecordList: '/manage/io_record/list',
  /** 售后差异表 */
  ManageAfterSaleReportList: '/manage/report/aftersale_report/list',
  /** 质检记录 */
  ManageQualityInspectionList: '/manage/commodity/quality_inspection/list',
  /** 质检报告（批次） */
  ManageQualityInspectionBatchList: '/manage/commodity/quality_inspection_batch/list',
  /** 质检报告（批次）详情 */
  ManageQualityInspectionBatchDetail: '/manage/commodity/quality_inspection_batch/detail',
  /** 质检报告（批次）编辑 */
  ManageQualityInspectionBatchEdit: '/manage/commodity/quality_inspection_batch/edit',
  /** 对账汇总表 */
  StatementDetailReportList: '/manage/report/statement_detail_report/list',
  /** 商品标签 */
  ManageProductTag: '/manage/setting/product_tag/list',
  /** 收据类型 */
  ManageReceiptType: '/manage/platform/receipt_type/list',
  /** 工单类型 */
  ManageWorkOrderType: '/manage/platform/work_order_type/list',
  /** 工单 */
  ManageWorkOrder: '/manage/platform/work_order/list',
  /** 收据 */
  ManageReceipt: '/manage/platform/receipt/list',
  /** 自定义大屏参数 */
  CustomScreenParameterList: '/manage/setting/custom_screen',
  /** 记账凭证生成器 */
  Generator: '/manage/setting/generator',
  /** 自定义打印模版 */
  CustomPrintTemplateList: '/manage/setting/custom_template',
  /** 自定义页面 */
  CustomPageList: '/manage/setting/custom_page',
  /** 商品图片助手 */
  ProductPicAssistant: '/manage/setting/product_pic_assistant',
  /** 自定义弹窗广告 */
  CustomAdList: '/manage/setting/custom_ad',
  /** 小程序自定义跳转 */
  MiniProgramNavList: '/manage/setting/mini_program_nav',
  /** 绩效评分表 */
  PerformanceScoreList: '/manage/incoming/performance_score/list',
  /** 新建绩效评分表 */
  PerformanceScoreCreate: '/manage/incoming/performance_score/create',
  /** 编辑绩效评分表 */
  PerformanceScoreEdit: '/manage/incoming/performance_score/edit',
  /** 绩效评分表详情 */
  PerformanceScoreDetail: '/manage/incoming/performance_score/detail',
  /** 巡检汇总记录 */
  ManageInspectionSummaryRecordList: '/manage/report/inspection_summary_record/list',
  /** 巡检结果 */
  ManageInspectionResultList: '/manage/inspection_result/list',
  /** 编辑巡检结果 */
  ManageInspectionResultEdit: '/manage/inspection_result/edit',
  /** 新建巡检结果 */
  ManageInspectionResultCreate: '/manage/inspection_result/create',
  /** 巡检结果详情 */
  ManageInspectionResultDetail: '/manage/inspection_result/detail',
  /** 巡检任务（督检） */
  ManageInspectionSuperviseList: '/manage/inspection_supervise/list',
  /** 新建巡检任务（督检） */
  ManageInspectionSuperviseCreate: '/manage/inspection_supervise/create',
  /** 编辑巡检任务（督检） */
  ManageInspectionSuperviseEdit: '/manage/inspection_supervise/edit',
  /** 巡检任务（督检）详情 */
  ManageInspectionSuperviseDetail: '/manage/inspection_supervise/detail',
  /** 巡检模版 */
  ManageInspectionTempList: '/manage/inspection_temp/list',
  /** 新建巡检模版 */
  ManageInspectionTempCreate: '/manage/inspection_temp/create',
  /** 巡检模版编辑 */
  ManageInspectionTempEdit: '/manage/inspection_temp/edit',
  /** 采购差异表 */
  ManagePurchaseDiffReportList: '/manage/report/purchase_diff_report/list',
  /** 对账汇总表 */
  ManageReconciliationReportList: '/manage/report/reconciliation_report/list',
  /** 采购需求汇总 */
  ManagePurchaseSummaryList: '/manage/purchase_summary/list',
  /** 需方组汇总表 */
  ManageDemandGroupReportList: '/manage/report/demand_group_report/list',
  /** 采购商品备注 */
  ManagePurchaseSkuRemarkList: '/manage/purchase_order/purchase_sku_remark/list',
  /** 明厨亮灶 */
  ManageBrightKitchen: '/manage/bright_kitchen',
  /** 明厨亮灶全屏 */
  ManageBrightKitchenFullScreen: '/manage/bright_kitchen/full_screen',
  /** 违规记录 */
  ManageViolationRecordList: '/manage/violation_record/list',
  /** 滞销品列表 */
  ManageDeadStockList: '/manage/commodity/dead_stock/list',
  /** 就餐日历 */
  ManageDiningCalendarList: '/manage/cookbook/dining_calendar/list',
  /** 巡检任务 */
  ManageInspectionTaskList: '/manage/inspection_task/list',
  /** 巡检任务详情 */
  ManageInspectionTaskDetail: '/manage/inspection_task/detail',
  /** 留样 */
  ManageKeepSampleList: '/manage/keep_sample/list',
  /** 留样详情 */
  ManageKeepSampleDetail: '/manage/keep_sample/detail',
  /** 消杀列表 */
  ManageDisinfectList: '/manage/disinfect/list',
  /** 消杀详情 */
  ManageDisinfectDetail: '/manage/disinfect/detail',
  /** 晨检列表 */
  ManageMorningCheckList: '/manage/morning_check/list',
  /** 晨检详情 */
  ManageMorningCheckDetail: '/manage/morning_check/detail',
  /** 废弃物处理列表 */
  ManageWasteDisposalList: '/manage/waste_disposal/list',
  /** 项目列表 */
  ManageProjectList: '/manage/inquiry_quotation/project_manage/list',
  /** 项目详情 */
  ManageProjectDetail: '/manage/inquiry_quotation/project_manage/detail',
  /** 项目详情-单号查询 */
  ManageProjectDetailByNo: '/manage/inquiry_quotation/project_manage/detail_no',
  /** 项目新建 */
  ManageProjectCreate: '/manage/inquiry_quotation/project_manage/create',
  /** 项目编辑 */
  ManageProjectEdit: '/manage/inquiry_quotation/project_manage/edit',
  /** 项目复制 */
  ManageProjectCopy: '/manage/inquiry_quotation/project_manage/copy',
  /** 项目评标定标 */
  ManageProjectEvaluate: '/manage/inquiry_quotation/project_manage/evaluate',
  /** 新品提报 */
  ManageNewSubmissionList: '/manage/commodity/new_submission/list',
  /** 投诉建议 */
  ManageSuggestionList: '/manage/suggestion/list',
  /** 财务汇总表 */
  ManageFinancialReportList: '/manage/report/finance_report/list',
  /** 配送损耗表 */
  ManageDeliveryLossReportList: '/manage/report/delivery_loss_report/list',
  /** 报餐记录 */
  ManageMealRecordList: '/manage/cookbook/meal_record/list',
  /** 报餐记录详情 */
  ManageMealRecordDetail: '/manage/cookbook/meal_record/detail',
  /** 新建报餐记录 */
  ManageMealRecordCreate: '/manage/cookbook/meal_record/create',
  /** 编辑报餐记录 */
  ManageMealRecordEdit: '/manage/cookbook/meal_record/edit',
  /** 套餐需求汇总 */
  ManagePackageSummaryList: '/manage/cookbook/package_summary/list',
  /** 餐标汇总 */
  MealSummaryList: '/manage/cookbook/meal_summary/list',
  /** 餐标管理 */
  MealStandardList: '/manage/cookbook/meal_standard/list',
  /** 标签管理 */
  ManageTagList: '/manage/setting/tag_manage/list',
  /** 限价管理 */
  LimitPriceList: '/manage/inquiry_quotation/limit_price/list',
  /** 统一定价 */
  UniformPriceList: '/manage/inquiry_quotation/uniform_price/list',
  /** 周转筐统计 */
  BasketStatisticsList: '/manage/basket_statistics/list',
  /** 周转筐借还记录 */
  TurnoverBasketList: '/manage/turnover_basket/list',
  /** 周转筐借还记录详情 */
  TurnoverBasketDetail: '/manage/turnover_basket/detail',
  /** 新建周转筐借还记录 */
  TurnoverBasketCreate: '/manage/turnover_basket/create',
  /** 编辑周转筐借还记录 */
  TurnoverBasketEdit: '/manage/turnover_basket/edit',
  /** 开票记录 */
  ManageBillRecordList: '/manage/bill/bill_record/list',
  /** 开票记录详情 */
  ManageBillRecordDetail: '/manage/bill/bill_record/detail',
  /** 新建开票记录 */
  ManageBillRecordCreate: '/manage/bill/bill_record/create',
  /** 编辑开票记录 */
  ManageBillRecordEdit: '/manage/bill/bill_record/edit',
  /** 配送任务 */
  ManageDeliveryTaskList: '/manage/delivery_task/list',
  /** 新建配送任务 */
  ManageDeliveryTaskCreate: '/manage/delivery_task/create',
  /** 编辑配送任务 */
  ManageDeliveryTaskEdit: '/manage/delivery_task/edit',
  /** 配送任务详情 */
  ManageDeliveryTaskDetail: '/manage/delivery_task/detail',
  /** 配送任务一键排线 */
  ManageDeliveryTaskQuickWiring: '/manage/delivery_task/quick_wiring',
  /** 配送路线列表 */
  ManageDeliveryRouteList: '/manage/delivery_route/list',
  /** 新建配送路线 */
  ManageDeliveryRouteCreate: '/manage/delivery_route/create',
  /** 编辑配送路线 */
  ManageDeliveryRouteEdit: '/manage/delivery_route/edit',
  /** 配送路线详情 */
  ManageDeliveryRouteDetail: '/manage/delivery_route/detail',
  /** 溯源管理 */
  ManageSuyuanManage: '/manage/suyuan',
  /** 库存台账 */
  ManageInventoryStock: '/manage/inventory_stock/list',
  /** 库存台账（供方） */
  ManageInventorySupplyStock: '/manage/inventory_supply_stock/list',
  /** 实时库存 */
  ManageInventoryRealtime: '/manage/inventory_realtime',
  /** 实时库存（供方） */
  ManageInventorySupplyRealtime: '/manage/inventory_supply_realtime',
  /** 价格监控 */
  ManagePriceMonitor: '/manage/inquiry_quotation/monitor/list',
  /** 账户管理 */
  AccountList: '/manage/bill/account/list',
  /** 公告管理 */
  NoticeList: '/manage/setting/notice/list',
  /** 频道 */
  WebhookChannelList: '/manage/webhook_channel/list',
  /** 监管方非监管商品列表 */
  ManageUnsuperviseCommodityList: '/manage/unsupervise_commodity/list',
  /** 监管方非监管商品详情 */
  ManageUnsuperviseCommodityDetail: '/manage/unsupervise_commodity/detail',
  /** 缴费单 */
  PaymentReceipt: '/manage/cookbook/payment_receipt/list',
  /** 缴费单详情 */
  PaymentReceiptDetail: '/manage/cookbook/payment_receipt/detail',
  /** 缴费单新增 */
  PaymentReceiptCreate: '/manage/cookbook/payment_receipt/create',
  /** 缴费单编辑 */
  PaymentReceiptEdit: '/manage/cookbook/payment_receipt/edit',
  /** 缴费单报餐记录 */
  MealRecordDetail: '/manage/cookbook/meal_record/detail',
  /** 自用菜谱 */
  ManageSelfCookbook: '/manage/cookbook/self_cookbook/list',
  /** 自用菜谱详情 */
  ManageSelfCookbookDetail: '/manage/cookbook/self_cookbook/detail',
  /** 菜谱管理 */
  ManageCookbookList: '/manage/cookbook/cookbook_manage/list',
  /** 菜谱详情 */
  ManageCookbookDetail: '/manage/cookbook/cookbook_manage/detail',
  /** 新建公用菜谱 */
  ManageCookbookCreate: '/manage/cookbook/cookbook_manage/create',
  /** 复制公用菜谱 */
  ManageCookbookCopy: '/manage/cookbook/cookbook_manage/copy',
  /** 编辑公用菜谱 */
  ManageCookbookEdit: '/manage/cookbook/cookbook_manage/edit',
  /** 组合商品列表 */
  ProductCombinationList: '/manage/commodity/product_combination/list',
  /** 组合商品详情 */
  ProductCombinationDetail: '/manage/commodity/product_combination/detail',
  /** 组合商品编辑 */
  ProductCombinationEdit: '/manage/commodity/product_combination/edit',
  /** 组合商品新增 */
  ProductCombinationAdd: '/manage/commodity/product_combination/add',
  /** 申购单 */
  ApplyPurchaseList: '/manage/apply_purchase/list',
  /** 申购单详情 */
  ApplyPurchaseDetail: '/manage/apply_purchase/detail',
  /** 下达采购 */
  ApplySendPurchase: '/manage/apply_purchase/send_purchase',
  /** 编辑申购单 */
  ApplyPurchaseEdit: '/manage/apply_purchase/edit',
  /** 申购需求汇总 */
  ApplyPurchaseSummary: '/manage/apply_purchase/purchase_summary/list',
  /** 商品列表 */
  CommodityList: '/manage/commodity/list',
  /** 创建商品 */
  CommodityCreate: '/manage/commodity/create',
  /** 转商品 */
  CommodityTransferProduct: '/manage/commodity/transfer_product',
  /** 编辑商品 */
  CommodityUpdate: '/manage/commodity/update',
  /** 商品详情 */
  CommodityDetail: '/manage/commodity/detail',
  /** 创建列表 */
  PurchaserCreate: '/manage/incoming/purchaser/create',
  /** 需方列表 */
  PurchaserList: '/manage/incoming/purchaser/list',
  /** 需方详情 */
  PurchaserDetails: '/manage/incoming/purchaser/details',
  /** 需方编辑 */
  PurchaserUpdate: '/manage/incoming/purchaser/update',
  /** 供方列表 */
  IncomingSupplierList: '/manage/incoming/supplier/list',
  /** 供方创建 */
  IncomingSupplierCreate: '/manage/incoming/supplier/create',
  /** 供方创建 */
  IncomingSupplierEdit: '/manage/incoming/supplier/edit',
  /** 供方详情 */
  IncomingSupplierDetail: '/manage/incoming/supplier/detail',
  /** 未下单需方 */
  UnorderedPurchaserList: '/manage/incoming/unordered_purchaser/list',
  /** 供方资质过期 */
  SupplierQualificationExpiryList: '/manage/warning/supplier_qualification_expiry',
  /** 质检报告缺失 */
  WarningQualityReportMissingList: '/manage/warning/quality_report_missing',
  /** 差评采购单 */
  WarningBadReviewsPurchaseList: '/manage/warning/bad_reviews_purchase',
  /** 逾期送达采购单 */
  WarningOverdueDeliveryPurchaseList: '/manage/warning/overdue_delivery_purchase',
  /** 少送错送采购单 */
  WarningLessDeliveryPurchaseList: '/manage/warning/less_delivery_purchase',
  /** 包装破损采购单 */
  WarningDamagedPackagePurchaseList: '/manage/warning/damaged_package_purchase',
  /** 温湿度不达标采购单 */
  WarningTemperatureHumidityPurchaseList: '/manage/warning/temperature_humidity_purchase',
  /** 健康证过期 */
  WarningHealthCertificateExpiry: '/manage/warning/health_certificate_expiry',
  /** 健康证过期-供方列表 */
  WarningHealthCertificateExpirySupplierList: '/manage/warning/health_certificate_expiry/supplier',
  /** 健康证过期-需方列表 */
  WarningHealthCertificateExpiryPurchaserList: '/manage/warning/health_certificate_expiry/purchaser',
  /** 采购合同列表 */
  PurchaserContractList: '/manage/purchase_contract/list',
  /** 新建采购合同 */
  PurchaserContractCreate: '/manage/purchase_contract/create',
  /**
   * 复制采购合同
   * @param string id 采购合同id
   * @description 使用方式 ${PurchaserContractCopy}/${id}
   * */
  PurchaserContractCopy: '/manage/purchase_contract/copy',
  /**
   * 编辑采购合同
   * @param string id 采购合同id
   * @description 使用方式 ${PurchaserContractEdit}/${id}
   * */
  PurchaserContractEdit: '/manage/purchase_contract/edit',
  /**
   * 从报价单新增采购合同
   * @param string id 采购合同id
   * @description 使用方式 ${PurchaserContractAddForQuation}/${id}
   * */
  PurchaserContractAddForQuation: '/manage/purchase_contract/quotation/add',
  /**
   * 采购合同详情
   * @param string id 采购合同id
   * @description 使用方式 ${PurchaserContractDetail}/${id}
   * */
  PurchaserContractDetail: '/manage/purchase_contract/detail',
  /** 报价单列表 */
  ManageQuotationList: '/manage/inquiry_quotation/quotation/list',
  /** 报价单详情 */
  ManageQuotationDetail: '/manage/inquiry_quotation/quotation/detail',
  /** 报价单详情-单号查询 */
  ManageQuotationDetailByNo: '/manage/inquiry_quotation/quotation/detail_no',
  /** 报价单编辑 */
  ManageQuotationUpdate: '/manage/inquiry_quotation/quotation/update',
  /** 报价单创建 */
  ManageQuotationCreate: '/manage/inquiry_quotation/quotation/create',
  /** 报价单复制 */
  ManageQuotationCopy: '/manage/inquiry_quotation/quotation/copy',
  /** 创建采购单 */
  ManagePurchaseOrderCreate: '/manage/purchase_order/create',
  /** 采购单复制 */
  ManagePurchaseOrderCopy: '/manage/purchase_order/copy',
  /** 采购单补录 */
  ManagePurchaseOrderRepair: '/manage/purchase_order/repair',
  /**
   * 采购单列表
   */
  ManagePurchaseOrderList: '/manage/purchase_order/list',
  /** 公用采购单 */
  PurchaseOrderList: '/manage/purchase_order/list',
  /**
   * 采购单详情
   */
  ManagePurchaseOrderDetail: '/manage/purchase_order/detail',
  /**
   * 采购单编辑
   */
  ManagePurchaseOrderEdit: '/manage/purchase_order/edit',
  /**
   * 回单记录列表
   */
  ManageReturnReceiptRecordList: '/manage/return_receipt_record/list',
  ReconciliationListForManage: '/manage/bill/reconciliation/list',
  ReconciliationListByPaymentForManage: '/manage/bill/reconciliation/list',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetailForManage}/${statementNo}
   * */
  ReconciliationDetailForManage: '/manage/bill/reconciliation/detail',
  /** 编辑对账单 */
  ReconciliationEditForManage: '/manage/bill/reconciliation/edit',
  /** 询价单列表 */
  InquiryList: '/manage/inquiry_quotation/inquiry/list',
  /** 询价单创建 */
  InquiryCreate: '/manage/inquiry_quotation/inquiry/create',
  /** 询价单详情 */
  InquiryDetail: '/manage/inquiry_quotation/inquiry/detail',
  /** 询价单编辑 */
  InquiryEdit: '/manage/inquiry_quotation/inquiry/edit',
  /** 询价单复制 */
  InquiryCopy: '/manage/inquiry_quotation/inquiry/copy',
  /** 采购汇总表 */
  PurchaseReportList: '/manage/report/purchase_report/list',
  /** 食安统计表 */
  FoodSafetyReportList: '/manage/report/food_safety_report/list',
  /** 业务分析 */
  BusinessAnalysisList: '/manage/report/business_analysis/list',
  /** 经营分析 */
  OperationAnalysisList: '/manage/report/operation_analysis/list',
  /** 采购评价 */
  PurchaseEvaluateList: '/manage/report/purchase_evaluate/list',
  /** 验收标准详情 */
  AcceptanceCriteriaDetail: '/manage/commodity/acceptance_criteria/detail',
  /** 角色创建 */
  ManageRoleCreate: '/manage/role/create',
  /** 角色列表 */
  ManageRoleList: '/manage/role/list',
  /**
   * 角色编辑
   * ?roleId=${id}
   * */
  ManageRoleEdit: '/manage/role/editor',
  /**
   * 监管方供方绩效
   */
  ManagePerformanceList: '/manage/performance/list',
  /** 监管方实时监控全屏 */
  ManageRealtimeMonitor: '/manage/monitor/realtime_monitor',
  /** 监管方实时监控全屏 */
  ManageRealtimeMonitorFullScreen: '/manage/monitor/realtime_monitor_full_screen',
  /** 数据大屏 */
  ManageScreen: '/screen',
  /** 缴费记录 */
  PaymentRecords: '/manage/cookbook/payment_records/list',
  /** 缴费记录新建 */
  PaymentRecordsCreate: '/manage/cookbook/payment_records/create',
  /** 售后单 */
  AfterSales: '/manage/after_sales/list',
  /** 新增售后单 */
  AfterSalesCreate: '/manage/after_sales/create',
  /** 售后单详情 */
  AfterSalesDetail: '/manage/after_sales/detail',
  /** 售后单编辑 */
  AfterSalesEdit: '/manage/after_sales/edit',
  /**
   * 采购单详情
   */
  PurchaseOrderDetail: '/manage/purchase_order/detail',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetail}/${statementNo}
   * */
  StatementDetail: '/manage/bill/reconciliation/detail',
  /** 折扣定价单 */
  DiscountPriceList: '/manage/inquiry_quotation/discount_price/list',
  /** 折扣定价单详情 */
  DiscountPricesDetail: '/manage/inquiry_quotation/discount_price/detail',
  /** 折扣定价单编辑 */
  DiscountPricesEdit: '/manage/inquiry_quotation/discount_price/edit',
  /** 折扣定价单创建 */
  DiscountPricesCreate: '/manage/inquiry_quotation/discount_price/create',
  /** 折扣定价单复制 */
  DiscountPricesCopy: '/manage/inquiry_quotation/discount_price/copy',
  /** 折扣定价比价定价 */
  DiscountComparePrice: '/manage/inquiry_quotation/discount_price/compare_price',
  /** 折扣定价生成采购合同 */
  DiscountPurchaseContract: '/manage/inquiry_quotation/discount_price/purchase_contract',
  /** 商品行情价 */
  MarketPriceList: '/manage/inquiry_quotation/market_price/list',
  /** 商品行情价详情 */
  MarketPricesDetail: '/manage/inquiry_quotation/market_price/detail',
  /** 商品行情价编辑 */
  MarketPricesEdit: '/manage/inquiry_quotation/market_price/edit',
  /** 商品行情价创建 */
  MarketPricesCreate: '/manage/inquiry_quotation/market_price/create',
  /** 商品行情价复制 */
  MarketPricesCopy: '/manage/inquiry_quotation/market_price/copy',
  /** 行情价汇聚 */
  MarketPriceGatherList: '/manage/inquiry_quotation/market_price_gather/list',
  /** 需方画像 */
  PurchaserPortraitList: '/manage/incoming/purchaser_portrait/list',
  /** 司机绩效 */
  DriverPerformanceList: '/manage/driver_performance/list',
  /** 行车报警 */
  VehicleAlarmList: '/manage/vehicle_alarm/list',
  /** 现场监控 */
  LiveMonitor: '/manage/live_monitor/list',
  /** 现场监控全屏 */
  LiveMonitorFullScreen: '/manage/live_monitor/full_screen',
  /** 违规记录 */
  VolationRecordList: '/manage/live_monitor/violation_record/list',
  /** 执行台账记录 */
  ExecutionRecordList: '/manage/execution_record/list',
  /** 执行台账记录详情 */
  ExecutionRecordDetail: '/manage/execution_record/detail',
  /** 平台对接详情 */
  PlatformDockingDetail: (id: number) => `/manage/setting/platform_docking/detail?id=${id}`,
  /** 门户网站 */
  ManagePortal: (tab?: string) => `/manage/portal${tab ? `?tab=${tab}` : ''}`,
  /** 图文编辑 */
  ManagePortalEdit: (id?: string) => `/manage/portal/edit${id ? `?id=${id}` : ''}`,
  /** 四单匹配 */
  ManageFourMatchList: '/manage/audit_manage/four_match/list',
  /** 财务合规审查 */
  ManageFinancialComplianceList: '/manage/audit_manage/financial_compliance/list',
  /** 预算编制 */
  ManageBudgetPreparationList: '/manage/budget_preparation/list',
  /** 预算跟踪 */
  ManageBudgetPreparationTracking: '/manage/budget_preparation/tracking',
  /** 运营日报 */
  ManageOperationDailyList: '/manage/operation_daily/list',
  /** 进项核算 */
  ManageInputAccountingList: '/manage/bill/input_accounting/list',
  /** 销项核算 */
  ManageOutputAccountingList: '/manage/bill/output_accounting/list',
  /** 抽检记录 */
  ManageSamplingInspectionList: '/manage/sampling_inspection/list',
  /** 抽检记录详情 */
  ManageSamplingInspectionDetail: '/manage/sampling_inspection/detail',
  /** 新建抽检记录 */
  ManageSamplingInspectionCreate: '/manage/sampling_inspection/create',
  /** 编辑抽检记录 */
  ManageSamplingInspectionEdit: '/manage/sampling_inspection/edit',
  /** 投筐记录列表 */
  ManageBasketDeliveryList: '/manage/basket_delivery/list',
  /** 投筐记录详情 */
  ManageBasketDeliveryDetail: '/manage/basket_delivery/detail',
  /** 新建投筐记录 */
  ManageBasketDeliveryCreate: '/manage/basket_delivery/create',
  /** 编辑投筐记录 */
  ManageBasketDeliveryEdit: '/manage/basket_delivery/edit',
  /** 菜品分类列表 */
  ManageDishCategoryList: '/manage/dish_category/list',
  /** 资金记录列表 */
  ManageFundRecordList: '/manage/fund_record/list',
  /** 部门列表 */
  ManageDepartmentList: '/manage/department/list',
  /** 记账凭证列表 */
  ManageVoucherList: '/manage/voucher/list',
  /** 记账凭证详情 */
  ManageVoucherDetail: '/manage/voucher/detail',
  /** 经营计算器 */
  ManageBusinessCalculatorList: '/manage/business_calculator/list',
};
